import {createAction, props} from '@ngrx/store';
import {
    DaveMutationChangePasswordArgs, DaveMutationResetUserTwoFactorArgs,
    DaveMutationSetupOtpArgs,
    DaveMutationVerifyTwoFactorArgs,
    SetupOtpType,
} from '../../graphql-types';
import { GatewayResponseErrorType } from '../../services/app-gateway.service';
import { TwoFactorMethodEnum } from '../../entities/user.entity';
import { Require } from '../../../helper/helper';

export type ErrorActionPayload = {
    ToasterMessage?: string,
    Err?: any,
    Caught?: any
}

export const BaseActionTypes = {
    PerformLoginRequest: createAction(
        'login/Request',
        props<{ Payload: { Username: string; Password: string; trustedDeviceToken?: string } }>()
    ),
    PerformLoginSuccess: createAction(
        'login/Success',
        props<{
            Payload: {
                token: string | null;
                challengeId: string | null;
                twoFactorMethod: TwoFactorMethodEnum;
            }
        }>()
    ),
    PerformLoginFailure: createAction(
        'login/Failure',
        props<{ Payload: { Errors: any; ToasterMessage?: string } }>()
    ),
    PerformMFARequest: createAction(
        'login/mfa/request',
        props<{ Payload: Require<DaveMutationVerifyTwoFactorArgs, 'challengeId' | 'code' | 'trustThisDevice'> }>()
    ),
    PerformMFASuccess: createAction(
        'login/mfa/success',
        props<{ Payload: { token: string, trustedDeviceToken: string } }>()
    ),
    PerformMFAFailure: createAction(
        'login/mfa/failure',
        props<{ Payload: { Errors: any; ToasterMessage?: string } }>()
    ),
    SendNewMFAMail: createAction(
        'login/mfa/sendNewMail/request',
        props<{ Payload: { challengeId: string } }>()
    ),
    SendNewMailSuccess: createAction(
        'login/mfa/sendNewMail/success',
        props<{ Payload: { challengeId: string } }>()
    ),
    SendNewMailFailure: createAction(
        'login/mfa/sendNewMail/failure',
        props<{ Payload: { Errors: any; ToasterMessage?: string } }>()
    ),
    CheckToken: createAction(
        'token/check'
    ),
    UpdateToken: createAction(
        'token/update',
        props<{ Payload: string }>()
    ),
    ChangePassword: createAction(
        'user/password/modify',
        props<{ Payload: DaveMutationChangePasswordArgs }>()
    ),
    ResetPassword: createAction(
        'user/password/reset',
        props<{ Payload: any }>()
    ),
    ActivateUser: createAction(
        'user/user/activate',
        props<{ Payload: any }>()
    ),
    InitStore: createAction(
        'data/init'
    ),
    ErrorAction: createAction(
        'error',
        props<{
            Payload: {
                ToasterMessage: string,
                Err?: any,
                Caught?: any
            }
        }>()
    ),
    /**
     * Setup OTP (2FA)
     */
    SetupMailOtpRequest: createAction(
        'user/otp/setup-email/request',
    ),
    SetupMailOtpSuccess: createAction(
        'user/otp/setup-email/success',
        props<{ Payload: SetupOtpType }>()
    ),
    SetupMailOtpFailure: createAction(
       'user/otp/setup-email/failure',
        props<{ Payload: { Errors: any; ToasterMessage?: string } }>(),
    ),

    RemoveOTPRequest: createAction(
        'user/otp/remove/request',
    ),
    RemoveOTPSuccess: createAction(
        'user/otp/remove/success',
    ),
    RemoveOTPFailure: createAction(
       'user/otp/remove/failure',
        props<{ Payload: { Errors: any; ToasterMessage?: string } }>(),
    ),

    SetupTOTPSuccess: createAction(
        'user/otp/setup-totp/success',
    ),
};
